<div *ngIf="mergePricingInfos.length > 0; else noPricingInfo"
     class="pricingContextFormatter">
    <div [class.ghost]="ghostMode">
        <ng-container *ngFor="let mergePricingInfo of mergePricingInfos; let i = index">
            <ion-item class="pricing" *ngIf="canDisplaySubscriptionName()">
                <div class="pricing-container">
                    <div class="xlarge-ghost-size pricing-title"
                         *ngIf="mergePricingInfo.pricingInfoDetails">
                        <ng-container
                                *ngFor="let pricingInfoDetail of mergePricingInfo.pricingInfoDetails; let last = last;">
                            <ng-container
                                    *ngTemplateOutlet="pricingInfoDetail.containCurrentSubscription ? boldTitle : normalTitle; context: {title :pricingInfoDetail.subscriptionTitle}">
                            </ng-container>
                            <span [hidden]="last">, </span>
                        </ng-container>
                    </div>

                    <ul class="pricing-content">
                        <li *ngFor="let line of mergePricingInfo.lines"
                            [innerHTML]="line"
                            class="ghost-hidden pricing-content-info"><br>
                        </li>
                    </ul>
                </div>
            </ion-item>

            <div class="pricing" *ngIf="!canDisplaySubscriptionName()">
                <ul class="pricing-content">
                    <li *ngFor="let line of mergePricingInfo.lines"
                        [innerHTML]="line"
                        class="ghost-hidden pricing-content-info"><br>
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>

    <ng-template #boldTitle let-title="title">
        <span [innerHTML]="'<b>' + title + '</b>'"></span>
    </ng-template>

    <ng-template #normalTitle let-title="title">
        <span [innerHTML]="title"></span>
    </ng-template>
</div>


<ng-template #noPricingInfo>
    <div class="noPricing">
        <p class="ghost-hidden">{{'chargePoint.noPricingInfo' | translate}}</p>
    </div>
</ng-template>
